import Component from 'Component';
import EmailAutofocus from "./form/EmailAutofocus";
import PasswordSwitch from "./form/PasswordSwitch";
import PasswordGenerator from "./form/PasswordGenerator";
import Submitter from "./form/Submitter";
import Filters from "./form/Filters";
import WYSIWYGEditor from "./form/WYSIWYGEditor";
import CodeEditor from "./form/CodeEditor";
import BlockEditor from "./form/BlockEditor";
import Sales from "./form/Sales";
import ColorPicker from "./form/ColorPicker";
import PurchaseConditionTargeting from "./form/PurchaseConditionTargeting";
import DatePicker from "./form/DatePicker";
import TimePicker from "./form/TimePicker";
import DateRangePicker from "./form/DateRangePicker";
import Select from "./form/Select";
import TreeSelect from "./form/TreeSelect";

export default class Form extends Component {

  _namespace = this.constructor.name;

  _components = [
    new Submitter(this.App, this._namespace),
    new Filters(this.App, this._namespace),
    new Sales(this.App, this._namespace),
    new EmailAutofocus(this.App, this._namespace),
    new PasswordSwitch(this.App, this._namespace),
    new PasswordGenerator(this.App, this._namespace),
    new ColorPicker(this.App, this._namespace),
    new PurchaseConditionTargeting(this.App, this._namespace),
    new Select(this.App, this._namespace),
    new TreeSelect(this.App, this._namespace),

    // Editors
    new WYSIWYGEditor(this.App, this._namespace),
    new CodeEditor(this.App, this._namespace),
    new BlockEditor(this.App, this._namespace),

    // Date and time pickers
    new DatePicker(this.App, this._namespace),
    new DateRangePicker(this.App, this._namespace),
    new TimePicker(this.App, this._namespace),

  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    super.initialize();
    return this;
  }

}